let stickyHidingTimeout = null;
import overunder from "overunder";

let Header = {
  dom: {
    header: document.querySelector('.header'),
    smooth: document.querySelector('.smooth--navigation'),
    headlines: document.querySelector('.js-headlines')
  },
  init() {
    this.handleNavigation(this.dom.header);
    this.handleStickyNav(this.dom.header, this.dom.headlines);
  },

  handleStickyNav(header, headlines) {

    const companyLink = document.querySelector('.js-company'),
      companyBlock = document.getElementById('company'),
      productBlock = document.getElementById('product'),
      productLink = document.querySelector('.js-product'),
      supplyBlock = document.getElementById('supply'),
      supplyLink = document.querySelector('.js-supply'),
      teamBlock = document.getElementById('team'),
      teamLink = document.querySelector('.js-team'),
      supplyMap = document.querySelector('.js-map'),
      contactBlock = document.getElementById('contact'),
      companyText = document.querySelector('.js-about-company'),
      contactLink = document.querySelector('.js-contact');


    const scroller = overunder.scroll(100, headlines, {watchResize: true, negativeOffset: 0});
    console.log('hey',scroller);
    scroller.on('under', (instance) => {
      // over endWaypoint offset top
        this.unselectAll();
      header.classList.remove('sticky');
    })
    scroller.on('over', (instance) => {
      // over endWaypoint offset top
      header.classList.add('sticky');
    })
    scroller.init().update();



    const companyScrollr = overunder.scroll(companyBlock, productBlock, {watchResize: true, offset: 60});
    companyScrollr.on('under', (instance) => {
      this.unselectAll();
    })
    companyScrollr.on('between', (instance) => {
      this.unselectAll();
      companyLink.classList.add('active');
    })

    companyScrollr.init();

    const companyTextScrollr = overunder.scroll(companyBlock, productBlock, {watchResize: true, offset: 400});
    companyTextScrollr.on('between', (instance) => {
      companyText.classList.add('active');
    })

    companyTextScrollr.init();

    const productShow = overunder.scroll(productBlock, supplyBlock, {watchResize: true, offset: 400});
    productShow.on('between', (instance) => {
      let text = productBlock.querySelector('.text--wrapper');
      text.classList.add('visible');
    })
    productShow.init();

    const productScrollr = overunder.scroll(productBlock, supplyBlock, {watchResize: true, offset: 60});
    productScrollr.on('under', (instance) => {
      this.unselectAll();
      companyLink.classList.add('active');
    })
    productScrollr.on('between', (instance) => {
      this.unselectAll();
      productLink.classList.add('active');
    })
    productScrollr.init();

    const supplyText = overunder.scroll(supplyBlock, teamBlock, {watchResize: true, offset: 400});

    supplyText.on('between', (instance) => {
      let text = supplyBlock.querySelector('.text--wrapper');
      text.classList.add('visible');
    })
    supplyText.init();

    const supplyMapS = overunder.scroll(supplyMap, teamBlock, {watchResize: true, offset: 600});

    supplyMapS.on('between', (instance) => {
      supplyMap.classList.add('active');
    })
    supplyMapS.init();

    const supplyScrollr = overunder.scroll(supplyBlock, teamBlock, {watchResize: true, offset: 60});
    supplyScrollr.on('under', (instance) => {
      this.unselectAll();
      productLink.classList.add('active');
    })
    supplyScrollr.on('between', (instance) => {
      this.unselectAll();
      supplyLink.classList.add('active');
    })
    supplyScrollr.init();

    const teamScrollr = overunder.scroll(teamBlock, contactBlock, {watchResize: true, offset: 60});
    teamScrollr.on('under', (instance) => {
      this.unselectAll();
      supplyLink.classList.add('active');
    })
    teamScrollr.on('between', (instance) => {
      this.unselectAll();
      teamLink.classList.add('active');
    })
    teamScrollr.on('over', (instance) => {
      this.unselectAll();
      contactLink.classList.add('active');
    })
    teamScrollr.init();

    const heroScrollr = overunder.scroll(0, companyBlock, {watchResize: true, offset: 60});
    heroScrollr.on('under', (instance) => {
      this.unselectAll();
    })
    heroScrollr.on('between', (instance) => {
      this.unselectAll();
    })

    heroScrollr.init();
  },
  unselectAll() {
    let nav = document.querySelectorAll('.nav-link');
    [].forEach.call(nav, (item) => {
      item.classList.remove('active');
    })
  },

  handleNavigation(header) {
    let toggle     = header.querySelector('.js-toggle-nav');

    // Only apply the transition style to the mobile navigation
    // while it's opening to prevent the resize flicker

    toggle.addEventListener('click', () => {
      if (header.classList.contains('opening')) {

        header.classList.remove('open');
        setTimeout(() => {
          header.classList.remove('opening');
        }, 250);

      } else {
        header.classList.add('opening');

        // open after we apply a transition class
        setTimeout(() => {
          header.classList.add('open');
        }, 100);
      }
    });

    this.resizeUnClass(header);
  },
  resizeUnClass(header) {
		// Remove classes applied to search/navigation/mobile
		window.addEventListener('resize', function(event) {
      header.classList.remove('open');
		});
  },
}

export default Header;



/** WEBPACK FOOTER **
 ** ./es6/global/header.js
 **/